import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { styled } from '../../system';
const StyledStack = styled('div', {
    d: 'flex',
    variants: {
        flow: {
            column: {
                flexDirection: 'column'
            },
            'column-reverse': {
                flexDirection: 'column-reverse'
            },
            row: {
                flexDirection: 'row'
            },
            'row-reverse': {
                flexDirection: 'row-reverse'
            }
        }
    }
});
export const Stack = forwardRef(({ flow = 'row', gap, ...props }, ref) => {
    var _a;
    return (_jsx(StyledStack, { ref: ref, ...props, css: { ...props.css, gap: gap !== null && gap !== void 0 ? gap : (_a = props.css) === null || _a === void 0 ? void 0 : _a.gap }, flow: flow }));
});
Stack.displayName = 'Stack';
